import { render, staticRenderFns } from "./ViewpointToggle.vue?vue&type=template&id=7a07ae78&"
import script from "./ViewpointToggle.vue?vue&type=script&lang=ts&"
export * from "./ViewpointToggle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports